interface ErrorDisplayProps {
  message?: string;
}

export function ErrorDisplay({ message }: ErrorDisplayProps) {
  return (
    <div className="flex h-full items-center justify-center bg-surface p-6">
      <div className="pane max-w-md border-err-mark/40 bg-err-tint px-5 py-4 text-center">
        <h2 className="mb-1 text-sm font-semibold text-err">
          Something went wrong
        </h2>
        <p className="text-xs break-words text-ink-2">{message}</p>
      </div>
    </div>
  );
}
